export default function (_a) {
    var env = _a.env, data = _a.data, outputs = _a.outputs, inputs = _a.inputs, onError = _a.onError;
    inputs['params'](function (val, relOutpus) {
        var _a;
        if (!!val) {
            try {
                var decodedToken = env.jwt.verify(val, data.secretKey);
                relOutpus['rtn'](decodedToken);
            }
            catch (error) {
                onError("\u89E3\u6790jwt\u51FA\u9519\uFF1A".concat((_a = error === null || error === void 0 ? void 0 : error.message) !== null && _a !== void 0 ? _a : '未知错误'));
            }
        }
        else {
            onError('解析jwt的参数必须存在');
        }
    });
}
